import { html } from "htm/preact";
import { hydrate } from "preact";
import LocaleSwitcherFooter from "../components/LocaleSwitcherFooter.js";

const containers = document.querySelectorAll("[data-locale-switcher-footer]");
const locales = JSON.parse(document.getElementById("locales-footer").innerHTML);
const pages = JSON.parse(document.getElementById("pages-footer").textContent);

containers.forEach((el) => {
  if (el) {
    const lang = el.dataset.lang;

    hydrate(html`<${LocaleSwitcherFooter} lang=${lang} locales=${locales} pages=${pages} />`, el);
  }
})
